import { render, staticRenderFns } from "./CompareMaterialDialog.vue?vue&type=template&id=67ab3b7f&scoped=true"
import script from "./CompareMaterialDialog.vue?vue&type=script&lang=ts"
export * from "./CompareMaterialDialog.vue?vue&type=script&lang=ts"
import style0 from "./CompareMaterialDialog.vue?vue&type=style&index=0&id=67ab3b7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ab3b7f",
  null
  
)

export default component.exports